module.exports = __webpack_public_path__ + "static/media/washingtonTutF.86fa2d63.jpg";